module.exports = __webpack_public_path__ + "static/media/一种基于活体的真人身份验证终端.fa868342.png";